import React from 'react';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const MagGlassIcon = ({ className }) => React.createElement(SVG, { viewBox: "0 0 24 24", className: className },
    React.createElement("g", null,
        React.createElement("path", { d: "M19,9.5A9.5,9.5,0,1,1,9.5,0,9.5,9.5,0,0,1,19,9.5Z", transform: "translate(2 2)", fill: "none", stroke: "#505271", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M2,2,0,0", transform: "translate(20 20)", fill: "none", stroke: Colours.sexternary, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M0,0H24V24H0Z", fill: "none", opacity: "0" })));
export default MagGlassIcon;
//# sourceMappingURL=MagGlassIcon.js.map